import { CheckoutRedirectHandler } from "../CheckoutRedirectHandler";
import { ManagerWithPMC } from "../StripeElementsManager/ManagerWithPMC";
import { CheckoutDescription } from "./CheckoutDescription";
import { CheckoutForm } from "./CheckoutForm";
import { SSOLoginPrompt } from "./SSOLoginPrompt";
import { Container } from "./components/Container";
import { GridColumns } from "./components/GridColumns";

export const CheckoutV2 = () => (
  <Container className="lg:pb-8">
    <GridColumns className="h-full gap-y-6 *:px-5 *:lg:pt-0">
      <CheckoutDescription className="!bg-secondary pb-8 lg:pr-10 xl:pr-36" />
      <SSOLoginPrompt className="lg:pl-10 xl:pl-36" />
      <ManagerWithPMC>
        <CheckoutForm className="pb-8 lg:pl-10 xl:pl-36" />
      </ManagerWithPMC>
    </GridColumns>
    <CheckoutRedirectHandler />
  </Container>
);
